import React from "react";
import PublicLayout from "@/components/layout/PublicLayout";
import TrendingOnCBR from "@/components/TrendingOnCBR";

export default function Trending() {
  return (
    <PublicLayout>
      <div data-testid="trending-page" className="min-h-[60vh] bg-[#0A192F]">
        <h1 className="sr-only">Trending on CBR — Canadian Baseball Activity</h1>
        <TrendingOnCBR />
      </div>
    </PublicLayout>
  );
}
